/* 
  市区管理
*/
import request from "@/utils/request";

//获取市区管理信息分页列表
export function getCityList(params) {
  return request({
    url: "/sysmange/district/getDistrict",
    method: "get",
    params
  });
}

//添加或者编辑市区信息
export function saveOrUpdate(data) {
  return request({
    url: "/sysmange/district/saveOrUpdate",
    method: "post",
    data
  });
}

//删除市区信息
export function deleteDistrict(data) {
  return request({
    url: "/sysmange/district/deleteDistrict",
    method: "post",
    data
  });
}
